// extracted by mini-css-extract-plugin
module.exports = {"cls1":"IconButtons-IconButton-module--cls1--3r6Pg","cls2":"IconButtons-IconButton-module--cls2--ixfDW IconButtons-IconButton-module--cls1--3r6Pg"};